import { useState, useEffect } from 'react';
import type { GenericERC721Token, GenericERC1155Token } from '1stdibs-contracts/typechain';

import { useWeb3Connection } from './useWeb3Connection';
import { getGenericTokenContract, getGeneric1155TokenContract } from './contracts/getContract';
import { useWeb3EagerConnect } from './useWeb3EagerConnect';

export function useTokenContractByAddress(
    contractAddress: string | undefined | null,
    isERC1155?: boolean
): GenericERC721Token | GenericERC1155Token | null {
    useWeb3EagerConnect();
    const { alchemyProvider } = useWeb3Connection();
    const [contract, setContract] = useState<GenericERC721Token | GenericERC1155Token | null>(null);
    useEffect(() => {
        if (alchemyProvider && contractAddress) {
            if (isERC1155) {
                getGeneric1155TokenContract(alchemyProvider, contractAddress).then(result => {
                    setContract(result);
                });
            } else {
                getGenericTokenContract(alchemyProvider, contractAddress).then(result => {
                    setContract(result);
                });
            }
        }
    }, [contractAddress, alchemyProvider, isERC1155]);

    return contract;
}
